module.exports = __webpack_public_path__ + "img/card_240400745.db3ef0c5.jpg";